module.exports = __webpack_public_path__ + "static/media/LCSH-ParentHandbook.a9383d08.pdf";